"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AbiCoder", {
  enumerable: true,
  get: function get() {
    return _abi.AbiCoder;
  }
});
Object.defineProperty(exports, "checkResultErrors", {
  enumerable: true,
  get: function get() {
    return _abi.checkResultErrors;
  }
});
Object.defineProperty(exports, "defaultAbiCoder", {
  enumerable: true,
  get: function get() {
    return _abi.defaultAbiCoder;
  }
});
Object.defineProperty(exports, "EventFragment", {
  enumerable: true,
  get: function get() {
    return _abi.EventFragment;
  }
});
Object.defineProperty(exports, "FormatTypes", {
  enumerable: true,
  get: function get() {
    return _abi.FormatTypes;
  }
});
Object.defineProperty(exports, "Fragment", {
  enumerable: true,
  get: function get() {
    return _abi.Fragment;
  }
});
Object.defineProperty(exports, "FunctionFragment", {
  enumerable: true,
  get: function get() {
    return _abi.FunctionFragment;
  }
});
Object.defineProperty(exports, "Indexed", {
  enumerable: true,
  get: function get() {
    return _abi.Indexed;
  }
});
Object.defineProperty(exports, "Interface", {
  enumerable: true,
  get: function get() {
    return _abi.Interface;
  }
});
Object.defineProperty(exports, "LogDescription", {
  enumerable: true,
  get: function get() {
    return _abi.LogDescription;
  }
});
Object.defineProperty(exports, "ParamType", {
  enumerable: true,
  get: function get() {
    return _abi.ParamType;
  }
});
Object.defineProperty(exports, "TransactionDescription", {
  enumerable: true,
  get: function get() {
    return _abi.TransactionDescription;
  }
});
Object.defineProperty(exports, "getAddress", {
  enumerable: true,
  get: function get() {
    return _address.getAddress;
  }
});
Object.defineProperty(exports, "getCreate2Address", {
  enumerable: true,
  get: function get() {
    return _address.getCreate2Address;
  }
});
Object.defineProperty(exports, "getContractAddress", {
  enumerable: true,
  get: function get() {
    return _address.getContractAddress;
  }
});
Object.defineProperty(exports, "getIcapAddress", {
  enumerable: true,
  get: function get() {
    return _address.getIcapAddress;
  }
});
Object.defineProperty(exports, "isAddress", {
  enumerable: true,
  get: function get() {
    return _address.isAddress;
  }
});
Object.defineProperty(exports, "base58", {
  enumerable: true,
  get: function get() {
    return _basex.Base58;
  }
});
Object.defineProperty(exports, "arrayify", {
  enumerable: true,
  get: function get() {
    return _bytes.arrayify;
  }
});
Object.defineProperty(exports, "concat", {
  enumerable: true,
  get: function get() {
    return _bytes.concat;
  }
});
Object.defineProperty(exports, "hexConcat", {
  enumerable: true,
  get: function get() {
    return _bytes.hexConcat;
  }
});
Object.defineProperty(exports, "hexDataSlice", {
  enumerable: true,
  get: function get() {
    return _bytes.hexDataSlice;
  }
});
Object.defineProperty(exports, "hexDataLength", {
  enumerable: true,
  get: function get() {
    return _bytes.hexDataLength;
  }
});
Object.defineProperty(exports, "hexlify", {
  enumerable: true,
  get: function get() {
    return _bytes.hexlify;
  }
});
Object.defineProperty(exports, "hexStripZeros", {
  enumerable: true,
  get: function get() {
    return _bytes.hexStripZeros;
  }
});
Object.defineProperty(exports, "hexValue", {
  enumerable: true,
  get: function get() {
    return _bytes.hexValue;
  }
});
Object.defineProperty(exports, "hexZeroPad", {
  enumerable: true,
  get: function get() {
    return _bytes.hexZeroPad;
  }
});
Object.defineProperty(exports, "isBytes", {
  enumerable: true,
  get: function get() {
    return _bytes.isBytes;
  }
});
Object.defineProperty(exports, "isBytesLike", {
  enumerable: true,
  get: function get() {
    return _bytes.isBytesLike;
  }
});
Object.defineProperty(exports, "isHexString", {
  enumerable: true,
  get: function get() {
    return _bytes.isHexString;
  }
});
Object.defineProperty(exports, "joinSignature", {
  enumerable: true,
  get: function get() {
    return _bytes.joinSignature;
  }
});
Object.defineProperty(exports, "zeroPad", {
  enumerable: true,
  get: function get() {
    return _bytes.zeroPad;
  }
});
Object.defineProperty(exports, "splitSignature", {
  enumerable: true,
  get: function get() {
    return _bytes.splitSignature;
  }
});
Object.defineProperty(exports, "stripZeros", {
  enumerable: true,
  get: function get() {
    return _bytes.stripZeros;
  }
});
Object.defineProperty(exports, "_TypedDataEncoder", {
  enumerable: true,
  get: function get() {
    return _hash._TypedDataEncoder;
  }
});
Object.defineProperty(exports, "hashMessage", {
  enumerable: true,
  get: function get() {
    return _hash.hashMessage;
  }
});
Object.defineProperty(exports, "id", {
  enumerable: true,
  get: function get() {
    return _hash.id;
  }
});
Object.defineProperty(exports, "isValidName", {
  enumerable: true,
  get: function get() {
    return _hash.isValidName;
  }
});
Object.defineProperty(exports, "namehash", {
  enumerable: true,
  get: function get() {
    return _hash.namehash;
  }
});
Object.defineProperty(exports, "defaultPath", {
  enumerable: true,
  get: function get() {
    return _hdnode.defaultPath;
  }
});
Object.defineProperty(exports, "entropyToMnemonic", {
  enumerable: true,
  get: function get() {
    return _hdnode.entropyToMnemonic;
  }
});
Object.defineProperty(exports, "HDNode", {
  enumerable: true,
  get: function get() {
    return _hdnode.HDNode;
  }
});
Object.defineProperty(exports, "isValidMnemonic", {
  enumerable: true,
  get: function get() {
    return _hdnode.isValidMnemonic;
  }
});
Object.defineProperty(exports, "mnemonicToEntropy", {
  enumerable: true,
  get: function get() {
    return _hdnode.mnemonicToEntropy;
  }
});
Object.defineProperty(exports, "mnemonicToSeed", {
  enumerable: true,
  get: function get() {
    return _hdnode.mnemonicToSeed;
  }
});
Object.defineProperty(exports, "getJsonWalletAddress", {
  enumerable: true,
  get: function get() {
    return _jsonWallets.getJsonWalletAddress;
  }
});
Object.defineProperty(exports, "keccak256", {
  enumerable: true,
  get: function get() {
    return _keccak.keccak256;
  }
});
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _logger.Logger;
  }
});
Object.defineProperty(exports, "computeHmac", {
  enumerable: true,
  get: function get() {
    return _sha.computeHmac;
  }
});
Object.defineProperty(exports, "ripemd160", {
  enumerable: true,
  get: function get() {
    return _sha.ripemd160;
  }
});
Object.defineProperty(exports, "sha256", {
  enumerable: true,
  get: function get() {
    return _sha.sha256;
  }
});
Object.defineProperty(exports, "sha512", {
  enumerable: true,
  get: function get() {
    return _sha.sha512;
  }
});
Object.defineProperty(exports, "SupportedAlgorithm", {
  enumerable: true,
  get: function get() {
    return _sha.SupportedAlgorithm;
  }
});
Object.defineProperty(exports, "solidityKeccak256", {
  enumerable: true,
  get: function get() {
    return _solidity.keccak256;
  }
});
Object.defineProperty(exports, "solidityPack", {
  enumerable: true,
  get: function get() {
    return _solidity.pack;
  }
});
Object.defineProperty(exports, "soliditySha256", {
  enumerable: true,
  get: function get() {
    return _solidity.sha256;
  }
});
Object.defineProperty(exports, "randomBytes", {
  enumerable: true,
  get: function get() {
    return _random.randomBytes;
  }
});
Object.defineProperty(exports, "shuffled", {
  enumerable: true,
  get: function get() {
    return _random.shuffled;
  }
});
Object.defineProperty(exports, "checkProperties", {
  enumerable: true,
  get: function get() {
    return _properties.checkProperties;
  }
});
Object.defineProperty(exports, "deepCopy", {
  enumerable: true,
  get: function get() {
    return _properties.deepCopy;
  }
});
Object.defineProperty(exports, "defineReadOnly", {
  enumerable: true,
  get: function get() {
    return _properties.defineReadOnly;
  }
});
Object.defineProperty(exports, "getStatic", {
  enumerable: true,
  get: function get() {
    return _properties.getStatic;
  }
});
Object.defineProperty(exports, "resolveProperties", {
  enumerable: true,
  get: function get() {
    return _properties.resolveProperties;
  }
});
Object.defineProperty(exports, "shallowCopy", {
  enumerable: true,
  get: function get() {
    return _properties.shallowCopy;
  }
});
Object.defineProperty(exports, "computePublicKey", {
  enumerable: true,
  get: function get() {
    return _signingKey.computePublicKey;
  }
});
Object.defineProperty(exports, "recoverPublicKey", {
  enumerable: true,
  get: function get() {
    return _signingKey.recoverPublicKey;
  }
});
Object.defineProperty(exports, "SigningKey", {
  enumerable: true,
  get: function get() {
    return _signingKey.SigningKey;
  }
});
Object.defineProperty(exports, "formatBytes32String", {
  enumerable: true,
  get: function get() {
    return _strings.formatBytes32String;
  }
});
Object.defineProperty(exports, "nameprep", {
  enumerable: true,
  get: function get() {
    return _strings.nameprep;
  }
});
Object.defineProperty(exports, "parseBytes32String", {
  enumerable: true,
  get: function get() {
    return _strings.parseBytes32String;
  }
});
Object.defineProperty(exports, "_toEscapedUtf8String", {
  enumerable: true,
  get: function get() {
    return _strings._toEscapedUtf8String;
  }
});
Object.defineProperty(exports, "toUtf8Bytes", {
  enumerable: true,
  get: function get() {
    return _strings.toUtf8Bytes;
  }
});
Object.defineProperty(exports, "toUtf8CodePoints", {
  enumerable: true,
  get: function get() {
    return _strings.toUtf8CodePoints;
  }
});
Object.defineProperty(exports, "toUtf8String", {
  enumerable: true,
  get: function get() {
    return _strings.toUtf8String;
  }
});
Object.defineProperty(exports, "Utf8ErrorFuncs", {
  enumerable: true,
  get: function get() {
    return _strings.Utf8ErrorFuncs;
  }
});
Object.defineProperty(exports, "UnicodeNormalizationForm", {
  enumerable: true,
  get: function get() {
    return _strings.UnicodeNormalizationForm;
  }
});
Object.defineProperty(exports, "Utf8ErrorReason", {
  enumerable: true,
  get: function get() {
    return _strings.Utf8ErrorReason;
  }
});
Object.defineProperty(exports, "accessListify", {
  enumerable: true,
  get: function get() {
    return _transactions.accessListify;
  }
});
Object.defineProperty(exports, "computeAddress", {
  enumerable: true,
  get: function get() {
    return _transactions.computeAddress;
  }
});
Object.defineProperty(exports, "parseTransaction", {
  enumerable: true,
  get: function get() {
    return _transactions.parse;
  }
});
Object.defineProperty(exports, "recoverAddress", {
  enumerable: true,
  get: function get() {
    return _transactions.recoverAddress;
  }
});
Object.defineProperty(exports, "serializeTransaction", {
  enumerable: true,
  get: function get() {
    return _transactions.serialize;
  }
});
Object.defineProperty(exports, "commify", {
  enumerable: true,
  get: function get() {
    return _units.commify;
  }
});
Object.defineProperty(exports, "formatEther", {
  enumerable: true,
  get: function get() {
    return _units.formatEther;
  }
});
Object.defineProperty(exports, "parseEther", {
  enumerable: true,
  get: function get() {
    return _units.parseEther;
  }
});
Object.defineProperty(exports, "formatUnits", {
  enumerable: true,
  get: function get() {
    return _units.formatUnits;
  }
});
Object.defineProperty(exports, "parseUnits", {
  enumerable: true,
  get: function get() {
    return _units.parseUnits;
  }
});
Object.defineProperty(exports, "verifyMessage", {
  enumerable: true,
  get: function get() {
    return _wallet.verifyMessage;
  }
});
Object.defineProperty(exports, "verifyTypedData", {
  enumerable: true,
  get: function get() {
    return _wallet.verifyTypedData;
  }
});
Object.defineProperty(exports, "_fetchData", {
  enumerable: true,
  get: function get() {
    return _web._fetchData;
  }
});
Object.defineProperty(exports, "fetchJson", {
  enumerable: true,
  get: function get() {
    return _web.fetchJson;
  }
});
Object.defineProperty(exports, "poll", {
  enumerable: true,
  get: function get() {
    return _web.poll;
  }
});
exports.RLP = exports.base64 = void 0;

var _abi = require("@ethersproject/abi");

var _address = require("@ethersproject/address");

var base64 = _interopRequireWildcard(require("@ethersproject/base64"));

exports.base64 = base64;

var _basex = require("@ethersproject/basex");

var _bytes = require("@ethersproject/bytes");

var _hash = require("@ethersproject/hash");

var _hdnode = require("@ethersproject/hdnode");

var _jsonWallets = require("@ethersproject/json-wallets");

var _keccak = require("@ethersproject/keccak256");

var _logger = require("@ethersproject/logger");

var _sha = require("@ethersproject/sha2");

var _solidity = require("@ethersproject/solidity");

var _random = require("@ethersproject/random");

var _properties = require("@ethersproject/properties");

var RLP = _interopRequireWildcard(require("@ethersproject/rlp"));

exports.RLP = RLP;

var _signingKey = require("@ethersproject/signing-key");

var _strings = require("@ethersproject/strings");

var _transactions = require("@ethersproject/transactions");

var _units = require("@ethersproject/units");

var _wallet = require("@ethersproject/wallet");

var _web = require("@ethersproject/web");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }